import React from 'react';
import { Box, Typography, Button, Container, useTheme } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';

const MaintenancePage: React.FC = () => {
    const theme = useTheme();
  return (
    <Box
      sx={{
        minHeight: '76vh',
        //background: 'linear-gradient(to right, #1e3c72, #2a5298)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.text.primary,
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
        <BuildIcon sx={{ fontSize: 80, mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          Maintenance
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          The Event Manager is currently being updated. Please check back later.
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => window.location.reload()}
        >
          Refresh
        </Button>
      </Container>
    </Box>
  );
};

export default MaintenancePage;